<template>
  <div>
    <signature-layout
      :submitSignature="sign"
      :signatureId="signatureId"
      :isLoading="isLoading"
      :foundRequest="found"
      :errorMessage="errorMessage"
      :workflowGuid="registration.workflowGuid"
      :submittedAt="registration.submittedAt"
    >
      <span slot="subtitle">
        Registration Application
      </span>
      <span slot="title">QT Dog Agreement</span>
      <div slot="approvedContent" v-if="registration && registration.requestId">
        <QTDogRegistrationRequest :registration="registration" />
      </div>
      <div slot="legalText">
        <p class="bottom-text">
          Upon signing, I testify that all data submitted is correct.
          I agree to abide by the <ASCAArtIncLink />, <BylawsLink />, rules of the ASCA Registries and all event programs, and to disciplinary action, if necessary, as determined by the Board of Directors of ASCA.
        </p>
      </div>
    </signature-layout>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import SignatureLayout from "@/components/common/SignatureLayout.vue";
import QTDogRegistrationRequest from "@/components/Portal/MyRequest/QTDogRegistrationRequest.vue";
import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
import BylawsLink from "@/components/common/BylawsLink.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";
import { getErrorMessage } from "@/services/errorHandler";

export default Vue.extend({
  name: "QTDogRegistrationSignature",
  components: {
    SignatureLayout,
    QTDogRegistrationRequest,
    ASCAArtIncLink,
    BylawsLink,
  },
  props: { signatureId: Number },
  data: function () {
    return {
      signatureText: "",
      errorMessage: "",
      registration: Object,
      isLoading: false,
      found: false,
      rulesDialog: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    toggleRules() { this.$data.rulesDialog = !this.$data.rulesDialog; },
    load: async function () {
      this.isLoading = true;
      this.errorMessage = "";
      this.found = false;

      try {
        const response = await workflowService.getQTDogDetailsForSignature(this.signatureId);
        this.found = response.found;

        if (response.found && (!response.errors || response.errors.length == 0)) {
          this.registration = response.data;
        } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'
      } catch (error) {
        this.errorMessage = getErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    sign: function (workflowGuid: String, signatureId: number, text: String) {
      workflowService
        .signDog(workflowGuid, signatureId, text)
        .then((res) => {
          this.$store.dispatch("loadPersonTasks");
          this.$navigate("/");
        }).catch(this.$handleError);
    },
  },
});
</script>
